import { createFileRoute } from "@tanstack/react-router";
import { AlcatrazStartPage } from "@/components/solutions/AlcatrazStartPage";
import { alcatrazStartSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/solutions/alcatraz-dms_/get-started")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) =>
    alcatrazStartSeo(loaderData?.href ?? "/solutions/alcatraz-dms/get-started"),
  component: AlcatrazStartPage,
});
